import React from "react";
import panelImg from "../images/panelImg.png";
import comingSoon from "../images/comingSoon.png"

function Panel() {
  return (
    <section className="panel" id="panel">
      <div className="panelCont flex">
        <div className="panelLeft" data-aos="fade-in">
         Global Survey Solutions operates its panel services under the name 5thPoll. 5thPoll is a quality-focused panel provider, offering access to a ready-made pool of verified respondents for fast and reliable market research insights. From recruitment and profiling to rigorous quality checks and data validation, we manage the end-to-end panel process to ensure accurate and trustworthy feedback.
          
          <br />
          <br />
         Our panel is built on strong verification standards, advanced fraud detection measures, and continuous engagement practices to maintain high data integrity. We support quantitative and qualitative research across multiple industries, enabling businesses to gather actionable insights with confidence. Whether you require targeted audience recruitment, survey sampling, or full-service panel management, 5thPoll delivers dependable data solutions that drive smarter strategies, product innovation, and informed marketing decisions.
        </div>
        <div className="panelRight">
        <div className="panelImgCont">
            <img src={panelImg} alt="" data-aos="fade-left"/>
            <div className="orangeStrip"></div>
        </div>
        <div className="panelHeadDiv">
          <div className="leftBorder">
            <div></div>
            <div></div>
          </div>
        <div className="panelHead" data-aos="fade-in">PANEL SERVICES</div>
        <div className="flex comingSoonDiv">
        <img src='panelLogo.png' data-aos="fade-right"/>
        </div>
        <div className="collab">Every Opinion Matters</div>
        <div className="flex" style={{justifyContent:"center"}}>
        <a href="https://5thpoll.com/" target="_blank" className="redirectBtn">VISIT 5TH POLL</a>
        </div>

        </div>
        </div>
      </div>
    </section>
  );
}

export default Panel;
